import React from 'react';
import { Box, Typography, Card, CardContent, Divider } from '@mui/material';

const formatExperience = (totalYears, totalMonths, totalDays) => {
    if (totalYears > 0) {
      const years = totalYears + totalMonths / 12;
      return `${years.toFixed(1)}Y`;
    } else if (totalMonths > 0) {
      return `${totalMonths}M`;
    } else {
      return `${totalDays}D`;
    }
  };

const ProfileInfo = ({ experience, annualLeave, sickLeave }) => {
  const { totalSerYr, totalSerMm, totalSerDd } = experience;
  const formattedExperience = formatExperience(totalSerYr, totalSerMm, totalSerDd);
  return (
    <div>
      <CardContent>
        <Box display="flex" flexDirection="row" alignItems="center" justifyContent="space-around">
        <Box display="flex" flexDirection="column" alignItems="center">
            <Typography variant="h6" style={{whiteSpace:"nowrap"}}>{annualLeave}H</Typography>
            <Typography variant="body1">AL</Typography>
          </Box>
          <Box display="flex" alignItems="center">
            <Divider orientation="vertical" style={{ height: '20px', margin: '0 8px' }} />
          </Box>
          <Box display="flex" flexDirection="column" alignItems="center">
            <Typography variant="h6" style={{whiteSpace:"nowrap"}}>{formattedExperience}</Typography>
            <Typography variant="body1">Experience</Typography>
          </Box>
          <Box display="flex" alignItems="center">
            <Divider orientation="vertical" style={{ height: '20px', margin: '0 8px' }} />
          </Box>
          <Box display="flex" flexDirection="column" alignItems="center">
            <Typography variant="h6" style={{whiteSpace:"nowrap"}}>{sickLeave}H</Typography>
            <Typography variant="body1">SL</Typography>
          </Box>
        </Box>
      </CardContent>
    </div>
  );
};

export default ProfileInfo;
